/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine   	       **
** ----------------------------------------------- **
**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
\*                                                 */

// Helps Loads New Sprite Instance
export class SpriteLoader {
  constructor(engine, world) {
    this.engine = engine;
    this.world = world;
    this.definitions = [];
    this.instances = {};
  }
  // Load Sprite
  async load(type, sceneName) {
    let afterLoad = arguments[2];
    let runConfigure = arguments[3];
    if (!this.instances[type]) {
      this.instances[type] = [];
    }
    // New Instance
    console.log("loading sprite - ", type, sceneName, "../../" + sceneName + "/sprites/" + type + ".jsx");

    let Type = this.world.sprites;
    let keys = type.split("/");
    console.log('search for sprite ...... ---->>>> ', type, keys, this.world.sprites)
    while (keys.length > 0) {
      let idx = keys.shift();
      console.log('search for sprite ...... ---->>>> ', idx, Type)
      Type = Type[idx];
    }

    let instance = new Type(this.engine);
    instance.templateLoaded = true;
    // Update Existing
    this.instances[type].forEach(function (instance) {
      if (instance.afterLoad) instance.afterLoad(instance.instance);
    });
    // Configure if needed
    if (runConfigure) runConfigure(instance);
    // once loaded
    if (afterLoad) {
      if (instance.templateLoaded) afterLoad(instance);
      else this.instances[type].push({ instance, afterLoad });
    }

    return instance;
  }
}
